import React from 'react'
import Loadable from 'react-loadable';
import Loading from 'components/common/Loading'
import { Switch, Route } from 'react-router-dom'
import RouteWithSubRoutes from 'components/common/RouteWithSubRoutes/RouteWithSubRoutes'

const EmailTemplatesDetailsPage = Loadable({
  loader: () => import(/* webpackChunkName:'EmailTemplatesDetailsPage' */ './Details/container'),
  loading: Loading,
});

const EmailTemplatesListPage = Loadable({
  loader: () => import(/* webpackChunkName:'EmailTemplatesListPage' */ './List/container'),
  loading: Loading,
});

export default () => (
  <RouteWithSubRoutes
    path="/email-templates"
    baseComponent={() => (
      <Switch>
        <Route exact path="/email-templates/:id" component={EmailTemplatesDetailsPage} />
        <Route exact path="/email-templates" component={EmailTemplatesListPage} />
      </Switch>
    )}
    subRoutes={[
      /^\/email-templates$/,
      /^\/email-templates\/new$/,
      /^\/email-templates\/(\d)+$/,
    ]}
  />
)
